import React from 'react';

import { CompanySelectModel } from 'api/adminApiClient';
import { ClientFilterTypes } from 'features/client/enums';
import { AssignmentFilterTypes } from 'features/assignment/enums';
import { ContractorCompanyFilterTypes } from 'features/admin/contractorCompany/enums';
import SelectWithLoading from 'hocs/withLoading/SelectWithLoading';

type FilterTypes =
  | ClientFilterTypes
  | AssignmentFilterTypes
  | ContractorCompanyFilterTypes;

type Props<T> = {
  filters: T;
  onChange: (data: T) => void;
  companies: CompanySelectModel[];
  isCompaniesLoaded: boolean;
  value?: string[];
};

export default function CompanyFilter<T>(props: Props<T>) {
  const { filters, companies, onChange, isCompaniesLoaded, value } = props;

  const handleFilterChange = (type: FilterTypes) => (value: string[]) => {
    onChange({
      ...filters,
      [type]: value,
    });
  };

  return (
    <SelectWithLoading
      isLoading={!isCompaniesLoaded}
      className="full-width"
      value={value}
      mode="multiple"
      optionFilterProp="children"
      placeholder="Select member"
      onChange={handleFilterChange(ClientFilterTypes.Company)}
      showSearch
    >
      {companies.map(({ companyId, companyName }) => (
        <SelectWithLoading.Option key={companyId} value={companyId || ''}>
          {companyName}
        </SelectWithLoading.Option>
      ))}
    </SelectWithLoading>
  );
}
